import { useFormatNumber } from 'core/hooks/useFormatNumber'

type RecapGvmValueProps = {
  label: string
  formatedValue: string
  progression: number | null
  isOmni: boolean
}

const RecapGvmValue = ({ label, formatedValue, progression, isOmni }: RecapGvmValueProps) => {
  const formatNumber = useFormatNumber()

  const formatPercent = (value: number | null) => {
    return formatNumber(value, '--', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      signDisplay: 'always',
      style: 'percent'
    })
  }

  const labelClass = isOmni ? 'vp-body-m' : 'vp-body-s'
  const valueClass = isOmni ? 'vp-subtitle-l' : 'vp-body-m'
  const isProgressionPositive = progression !== null && progression >= 0

  return (
    <div className="mg-store-trajectory-recap-gmv-card-body-item">
      <div
        className={'mg-store-trajectory-recap-gmv-card-body-item-label ' + labelClass}
        data-testid="recap-gvm-value-label"
      >
        {label}
      </div>
      <div
        className={'mg-store-trajectory-recap-gmv-card-body-item-value ' + valueClass}
        data-testid="recap-gvm-value-value"
      >
        {formatedValue}
        <span
          className={`mg-store-trajectory-recap-gmv-card-body-item-progression${
            isProgressionPositive ? '-positive' : '-negative'
          } vp-body-m`}
          data-testid="recap-gvm-value-progression"
        >
          {formatPercent(progression)}
        </span>
      </div>
    </div>
  )
}

export default RecapGvmValue
